import React from 'react';

/**
 * TikTok Logo als Inline-SVG. lucide-react hat (Stand 2026) noch kein
 * eigenes TikTok-Icon, deshalb selbst gerendert. API ist identisch zu
 * lucide-Komponenten (`className`, `size`, ...).
 */
export const TikTokIcon = ({ className = 'h-5 w-5', size, ...rest }) => {
  const dim = size ? { width: size, height: size } : {};
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" {...dim} {...rest}>
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.71a8.16 8.16 0 0 0 4.77 1.52V6.78a4.79 4.79 0 0 1-1.84-.09Z" />
    </svg>
  );
};

export default TikTokIcon;
